import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Lodash
import _values from 'lodash/values';
import _isFunction from 'lodash/isFunction';

// Components
import COLORS from '@tekion/tekion-styles-next/scss/variables.scss';
import Icon from '../../atoms/FontIcon';
import CircularProgressBar from '../CircularProgressBar';

// Constants
import { SIZES } from '../../atoms/FontIcon/Icon.constants';
import { LOADING_START_PERCENTAGE, LOADING_PAUSE_PERCENTAGE, STROKE_WIDTH, WIDTH } from './constants/progressBar.default';

// Helpers
import { getRandomPercentage } from './helpers/randomNumber';
var IconWithProgress = /*#__PURE__*/function (_Component) {
  _inherits(IconWithProgress, _Component);
  var _super = _createSuper(IconWithProgress);
  function IconWithProgress(props) {
    var _this;
    _classCallCheck(this, IconWithProgress);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "updateLoadingView", function () {
      var loadingPausePercentage = _this.props.loadingPausePercentage;
      var currentPercentage = _this.state.percent;
      var radomPercentage = getRandomPercentage();
      var newPercentage = currentPercentage + radomPercentage;
      if (newPercentage < loadingPausePercentage) {
        _this.setState({
          percent: newPercentage
        }, function () {
          return window.requestAnimationFrame(_this.updateLoadingView);
        });
      }
    });
    var loadingStartPercentage = props.loadingStartPercentage;
    _this.state = {
      percent: loadingStartPercentage
    };
    return _this;
  }
  _createClass(IconWithProgress, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var loading = this.props.loading;
      if (loading) {
        window.requestAnimationFrame(this.updateLoadingView);
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
        icon = _this$props.icon,
        iconSize = _this$props.iconSize,
        renderIcon = _this$props.renderIcon,
        showPercentage = _this$props.showPercentage,
        loadingStartPercentage = _this$props.loadingStartPercentage;
      var _this$state$percent = this.state.percent,
        percent = _this$state$percent === void 0 ? loadingStartPercentage : _this$state$percent;
      if (showPercentage) {
        return "".concat(percent, "%");
      }
      return _isFunction(renderIcon) ? renderIcon() : /*#__PURE__*/React.createElement(Icon, {
        size: iconSize
      }, icon);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        strokeWidth = _this$props2.strokeWidth,
        width = _this$props2.width,
        loadingStartPercentage = _this$props2.loadingStartPercentage,
        strokeColor = _this$props2.strokeColor;
      var _this$state$percent2 = this.state.percent,
        percent = _this$state$percent2 === void 0 ? loadingStartPercentage : _this$state$percent2;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement(CircularProgressBar, {
        strokeWidth: strokeWidth,
        type: "circle",
        width: width,
        percent: percent,
        strokeColor: strokeColor
      }, this.renderContent()));
    }
  }]);
  return IconWithProgress;
}(Component);
IconWithProgress.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  loadingPausePercentage: PropTypes.number,
  strokeWidth: PropTypes.number,
  width: PropTypes.number,
  loading: PropTypes.bool,
  loadingStartPercentage: PropTypes.number,
  strokeColor: PropTypes.string,
  iconSize: PropTypes.oneOf(_values(SIZES)),
  renderIcon: PropTypes.func,
  showPercentage: PropTypes.bool
};
IconWithProgress.defaultProps = {
  className: '',
  loadingPausePercentage: LOADING_PAUSE_PERCENTAGE,
  strokeWidth: STROKE_WIDTH,
  width: WIDTH,
  loading: false,
  loadingStartPercentage: LOADING_START_PERCENTAGE,
  strokeColor: COLORS.parisGreen,
  iconSize: SIZES.MD,
  renderIcon: undefined,
  showPercentage: false
};
export default IconWithProgress;